export default {
    
    // baseURL: 'http://192.168.10.7:8028/api/',
   
      baseURL: 'https://ksgl.zzydtec.com/api/',
   
    header: {
        'content-type': 'application/json'
    },
    method: 'GET',
    dataType: 'json',
    custom: {},
    timeout: 30000,
    // host:'http://rsks.zhongzhiyunda.com'
    host:""
    // host:"https://rsks.ycrkb.com"
}
